import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import feather from 'vue-icon'
import { CognitoUserPool } from 'amazon-cognito-identity-js'
import poolData from '@/pool-data'
import '@/scss/custom.scss'

Vue.use(feather, {
  name: 'v-icon',
  props: {
    baseClass: {
      type: String,
      default: 'v-icon'
    },
    classPrefix: {
      type: String,
      default: 'v-icon-'
    }
  }
})

Vue.use(BootstrapVue)

Vue.config.productionTip = false

// Check if page is loaded from an iframe tag
const { top, self, localStorage } = window
if (top !== self) {
  localStorage.setItem('from-iframe', true)
  top.location.replace(document.location.origin + '/')
}

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  watch: {
    $route: async (to, from) => {
      if (store.getters['auth/isAuthenticated']) {
        var userPool = new CognitoUserPool(poolData)
        var cognitoUser = userPool.getCurrentUser()

        if (!cognitoUser) {
          await store.dispatch('auth/expiredSessionSignOut')
          return
        }

        await cognitoUser.getSession(async (err, session) => {
          if (err) {
            await store.dispatch('auth/expiredSessionSignOut')
            return
          }

          if (!session) {
            await store.dispatch('auth/expiredSessionSignOut')
            return
          }

          if (!session.accessToken) {
            await store.dispatch('auth/expiredSessionSignOut')
          }
        })
      }
    }
  },
  render: h => h(App)
})
